import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { AUTH_TOKEN, COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import { hasEnabledFeature, isCRMImport } from 'globalutils/fmUtils';
import { toggleVisibility } from '../../utils';
import { getCookie } from 'globalservices/cookie';
import { checkServiceProvider } from './serviceProviderConfig';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const beBaseUrl = window?.$environment?.BE_BASE_URL;
const layout = window?.$environment?.CURRENT_LAYOUT;

const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));

export default function TemplateImport({ newUI, logBook }) {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const { t } = useTranslation();

  // Toggle modal visibility
  const toggleModal = () => toggleVisibility('importItems');

  // Download template logic
  const downloadTemplate = async (url, filename) => {
    try {
      const token = getCookie(COOKIE_AUTH_DETAILS)[AUTH_TOKEN];
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        a.click();
      } else {
        console.error('Error:', response.status);
      }
    } catch (error) {
      console.error('Download Error:', error);
    }

    toggleModal();
  };

  // Handle vehicle template download
  const handleVehicleTemplateDownload = () => {
    const isCRM = isCRMImport();
    const url = isCRM
      ? `${beBaseUrl}/vehicle/mini-import/template`
      : `${beBaseUrl}/vehicle/csvtemplate?token=${logBook?.documentToken}`;
    let filename = isCRM ? 'Vehicle_mini_import_template.csv' : 'Vehicle_import_template.csv';

    if (!isCRM && hasEnabledFeature('cameraIntegrationEnabled')) {
      filename = 'Camera_Integrated_Import_Data_vehicle.csv';
    }

    downloadTemplate(url, filename);
  };

  // Handle trailer template download
  const handleTrailerTemplateDownload = () => {
    const url = `${beBaseUrl}/trailer/csvtemplate?token=${logBook?.documentToken}`;
    document.getElementById('importVehicleTemplateFrame').src = url;
    toggleModal();
  };

  return (
    <>
      {/* Check if the export template should be displayed */}
      {checkServiceProvider('templateImport_export', SERVICE_PROVIDER) && (
        <Export
          src={layout === 'NewUi' ? mediaUrls?.importUserTemplate : mediaUrls.excel}
          filename={t('common.template')}
          toolTip={t('common.template')}
          className="importUserTemplateContainer"
          onClick={toggleModal}
          buttonName={t('common.template')}
          id="importUserTemplateContainer"
          newUI={newUI}
        />
      )}

      {/* Import Templates Modal */}
      <div id="importItems" className="vehicleModal">
        <ul>
          <li>
            <Link variant="body2" onClick={handleVehicleTemplateDownload}>
              {t('vehicles.importVehicleTemplate')}
            </Link>
          </li>
          <li>
            <Link variant="body2" onClick={handleTrailerTemplateDownload}>
              {t('vehicles.importTrailerTemplate')}
            </Link>
          </li>
        </ul>
      </div>

      {/* Hidden iframe for downloading templates */}
      <iframe id="importVehicleTemplateFrame" style={{ display: 'none' }} />
    </>
  );
}
